export function buildThemeImageMap(): Record<string, string> {
  const map: Record<string, string> = {};
  const questionnaire = window.customer?.questionnaireData;
  const allQuestions = window.customer?.questionnaireAllQuestions;

  if (questionnaire && Array.isArray(questionnaire.answers)) {
    questionnaire.answers.forEach((ans) => {
      if (ans?.title && ans?.image) map[ans.title] = ans.image;
    });
  }

  if (Array.isArray(allQuestions)) {
    allQuestions.forEach((q) => {
      if (q?.title && q?.image) map[q.title] = q.image;
    });
  }

  return map;
}
